import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { actualizarFoto } from "../../redux/actions";
import ErrorModal from "../../components/modals/errorModal";
import SuccessModal from "../../components/modals/successModal";
import Button from "../../components/button";

function UploadFotoToDetailComponent({
  id,
  imagen,
  closeUploadFoto,
  onFotoActualizada,
}) {
  const dispatch = useDispatch();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const openErrorModal = (message) =>
    setErrorModal({ show: true, message });

  const closeErrorModal = () =>
    setErrorModal({ show: false, message: "" });

  const handleConfirmar = async () => {
    setLoading(true);

    try {
      const formData = new FormData();

      // Convertir la imagen de base64 a un archivo Blob
      const blob = await fetch(imagen).then((res) => res.blob());

      const file = new File([blob], `foto_${Date.now()}.jpeg`, {
        type: "image/jpeg",
      });

      formData.append("foto", file);
      formData.append("id", id);

      const response = await dispatch(actualizarFoto(formData));

      if (response) {
        setShowSuccessModal(true);
      } else {
        openErrorModal("Hubo un error al subir la foto.");
      }
    } catch (error) {
      console.error("Error al subir la foto:", error);

      const serverErrorMessage =
        error.response?.data?.error ||
        "Error inesperado al subir la foto.";

      openErrorModal(serverErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);

    if (typeof onFotoActualizada === "function") {
      onFotoActualizada();
    }

    closeUploadFoto();
  };

  return (
    <div>
      <div className="flex min-h-screen flex-col items-center bg-black/90 inset-0 z-50 fixed">
        {imagen ? (
          <div className="flex flex-col items-center">
            <img
              src={imagen}
              alt="Imagen"
              className="w-[20rem] my-[3rem] rounded-lg overflow-hidden"
            />

            <div className="justify-center items-center flex">
              <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                <Button
                  variant="secondary"
                  size="lg"
                  fullWidth
                  type="button"
                  onClick={closeUploadFoto}
                  disabled={loading}
                >
                  Volver atrás
                </Button>

                <Button
                  size="lg"
                  fullWidth
                  type="button"
                  onClick={handleConfirmar}
                  loading={loading}
                >
                  Confirmar foto
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div>Hubo un problema al cargar la foto</div>
        )}
      </div>

      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="Foto subida con éxito."
        />
      )}

      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>
  );
}

export default UploadFotoToDetailComponent;